import { render, staticRenderFns } from "./IcnTheme.vue?vue&type=template&id=be9171f2&scoped=true"
import script from "./IcnTheme.vue?vue&type=script&lang=js"
export * from "./IcnTheme.vue?vue&type=script&lang=js"
import style0 from "./IcnTheme.vue?vue&type=style&index=0&id=be9171f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9171f2",
  null
  
)

export default component.exports